/**
 * Shared formatting helpers for the Enrollment View blocks.
 *
 * Centralised so every money cell renders consistently and never leaks
 * "NaN"/"undefined" into the UI when the backend omits a value.
 */

import { MONEY_DECIMALS } from "../../../config/money";

/** Format a numeric amount; blank/non-numeric values render as "0". */
export const fmtAmount = (n: any): string => {
  if (n == null || n === "") return "0";
  const num = Number(n);
  if (Number.isNaN(num)) return "0";
  // Precision from the single knob MONEY_DECIMALS (config/money); trailing zeros
  // trimmed (no forced minimum — renders "0" for blanks/integers cleanly).
  return num.toLocaleString(undefined, { maximumFractionDigits: MONEY_DECIMALS });
};

/**
 * Today's date as YYYY-MM-DD in the browser's *local* timezone.
 * Avoids `new Date().toISOString()` which is UTC and can be off by a day
 * for tenants ahead of/behind UTC (e.g. IST, Dubai) near midnight.
 */
export const todayLocalISO = (): string => {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};
